const role = {
  ADMIN: 1,
  DRIVER: 5,
  TEAMMEMBER: 2,
  GENERALMANAGER: 3,
  ISSUER: 4
}

export { role }
